<template>
  <DefaultResult :result="result" :highlight="true">
    <template v-slot>
      <a :href="result.url" class="group relative flex flex-col no-underline p-6 pb-4">

        <h3 class="text-2xl text-blue-700 group-hover:underline mb-1">
          <ais-highlight :hit="result" attribute="title" highlightedTagName="mark"></ais-highlight>
        </h3>

        <span v-if="beltStyle" class="-mx-6 mb-4 mt-2 block h-1.5 shrink-0" :style="beltStyle"></span>

        <p class="mb-0 text-gray-700" v-if="description" v-html="description">
        </p>

        <div class="mt-4 flex flex-wrap items-center gap-3 border-t border-gray-200 pt-4 -mx-6 px-6">
          <span v-if="result.certModules"
            class="inline-flex items-center gap-1.5  py-1 text-sm font-semibold text-gray-700">
            <svg-icon name="folders-fill" classes="size-3.5 text-gray-500" />
            {{ result.certModules }}
          </span>

          <span v-if="result.certSpanishAvailable === 'available' || result.certSpanishAvailable === 'comingSoon'"
            class="inline-flex items-center gap-1.5 rounded px-2.5 py-1 text-sm font-semibold"
            :class="result.certSpanishAvailable === 'comingSoon' ? 'text-gray-500' : 'text-orange-600'">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 shrink-0" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            {{ result.certSpanishAvailable === 'comingSoon' ? 'Spanish Coming Soon' : 'Spanish Available' }}
          </span>

          <span v-if="result.certPriceDisplay" class="ml-auto text-2xl font-semibold leading-none text-gray-900">
            {{ result.certPriceDisplay }}<span class="ml-1 text-xs font-normal text-gray-600">USD</span>
          </span>

          <span class="ml-auto leading-none font-semibold text-gray-900" v-if="notCertPage">View Details</span>
        </div>

      </a>
    </template>
  </DefaultResult>
</template>

<script>
import {
  AisHighlight,
  AisSnippet
} from 'vue-instantsearch/vue3/es'
import DefaultResult from '@js/components/search/results/DefaultResult.vue'
import SvgIcon from '@js/components/SvgIcon.vue'

export default {
  props: ['result'],

  components: {
    AisHighlight,
    AisSnippet,
    DefaultResult,
    SvgIcon
  },

  mounted() {
    console.log('cert result', this.result);
  },

  computed: {
    beltStyle() {
      const primary = this.result.certBeltClass
      const secondary = this.result.certBeltClassSecondary
      if (primary && secondary) {
        return `background: linear-gradient(90deg, ${primary} 50%, ${secondary} 50%)`
      }
      if (primary) {
        return `background: ${primary}`
      }
      return null
    },
    description() {
      return this.result.description || this.result.content
    },
    notCertPage() {
      return !this.result.certPriceDisplay
    }
  }
}
</script>
